const Roles = {
  TEACHER: 'teacher',
  CARER: 'carer'
};

export default Roles;
